import { Descriptions } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";
import { TicketTypedMetaField } from "../../../types/TicketMeta";

type Props = {
  meta: TicketTypedMetaField & { type: "string" };
};

export const MetaString = observer((props: Props) => {
  return (
    <Descriptions.Item label={props.meta.label} key={props.meta.label}>
      {props.meta.value}
    </Descriptions.Item>
  );
});
